import { alphaClient } from '@/services/api-client'

interface VehicleUuids {
  uuid: string
}

export const sendMileage = (vehicles: VehicleUuids[]): Promise<void> =>
  alphaClient.post('/integration/mileage', vehicles)
